import logger from "@/utils/logger.js";
import axios from "axios";
import { UserEntityModel } from "@/models/UserEntityModel.js";
import { checkToken } from '@/utils/lambdaUtils';
import { useAuthStore } from '@/stores/authStore';
import api from "@/services/api.js";

const baseUrl = import.meta.env.VITE_APP_API_BASE_URL + '/user_entities/';

export const getUserEntities = async () => {
    try {
        await checkToken();
        const store = useAuthStore();
        const response = await axios.get(`${baseUrl}get_user_entities`,
            {
                headers: {
                    'Authorization': `Bearer ${store.token}`,
                }
            });
        if (Array.isArray(response.data)) {
            return response.data.map(item => new UserEntityModel(item));
        } else {
            throw new Error('Invalid response data format');
        }
    } catch (error) {
        logger.error('Error getting user entity list', error);
    }
};

/**
 * Entity ids the current user holds an entity-scoped QA role (QA-HMO / QA-DHS) in.
 *
 * A plain user-entity association is not enough to participate in a QA exam, so this is the
 * correct scope for the HMO/CBP uploads page rather than the full userEntities list.
 */
export const getQaEntityIds = async () => {
    try {
        await checkToken();
        const response = await api.get(`${baseUrl}get_qa_entity_ids`);
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        logger.error('Error getting QA scoped entity ids', error);
        return [];
    }
};

export const insertUserEntity = async (id) => {    if (!id) {
        throw new Error('Missing required parameters');
    }

    try {
        await checkToken();
        const response = await api.post(`${baseUrl}insert_user_entity?id=${encodeURIComponent(id)}`);
        return response.data;
    } catch (error) {
        logger.error('Error inserting user entity', error);
        throw error;
    }
};

export const deleteUserEntity = async (id) => {
    if (!id) {
        throw new Error('Missing required parameters');
    }

    try {
        await checkToken();
        const response = await api.post(`${baseUrl}delete_user_entity?id=${encodeURIComponent(id)}`);
        return response.data;
    } catch (error) {
        logger.error('Error deleting user entity', error);
        throw error;
    }
};